import React, { useState, useEffect } from "react";
import "../Lp.css";
import { useSelector, useDispatch } from "react-redux";
import { useLocation, useHistory } from "react-router";
import { MdEmail } from "react-icons/md";
import {
  FaUserCircle,
  FaMapPin,
  FaLanguage,
  FaWhatsappSquare,
} from "react-icons/fa";
import { RiWhatsappFill } from "react-icons/ri";
//IMPORTING ACTIONS FOR REEDUX API CALL
import { getCityLpPage, getCall } from "../../../Redux/Actions";
import { Modal } from "react-responsive-modal";

const LpForm = ({
  position,
  butname,
  title,
  formId,
  isLp,
  isImagine,
  lpNumber,
  emailType,
  emailTitle,
  offerPrice,
  isMobile,
  buttonId,
  // setshowPopUp,
  minPhleboCharge,
}) => {
  const [userName, setUserName] = useState("");
  const [number, setNumber] = useState("");
  const [userNumber, setUserNumber] = useState("");
  const [userCity, setUserCity] = useState("");
  const [nameError, setNameEror] = useState("");
  const [phoneError, setPhoneEror] = useState("");
  const [displayCityList, setDisplay] = useState(true);
  const [success, setSucess] = useState(false);
  const [checkboxState, setCheckboxState] = useState(true);
  const [disable, setDisable] = useState(true);
  const [openSuccModel, setSucc] = useState(false);
  const [leadSource, setleadSource] = useState("");
  const [userEmail, setUserEmail] = useState("");
  const history = useHistory();

  useEffect(() => {
    if (isImagine) {
      setNumber("898 898 0606");
    } else if (isLp && lpNumber) {
      setNumber(lpNumber);
    } else {
      setNumber("898 898 8787");
    }
  }, [isImagine, lpNumber, isLp]);
  //cont
  const openSucess = () => setSucc(true);
  const closeSuccess = () => setSucc(false);

  useEffect(() => {
    if (
      userName == "" ||
      userCity == "" ||
      userNumber == "" ||
      (emailType ? userEmail == "" : null) ||
      userNumber.length !== 12
    ) {
      setDisable(true);
    } else {
      setDisable(false);
    }
  }, [userName, userCity, userNumber, emailType ? userEmail : null]);
  //calling city name api
  useEffect(() => {
    dispatch(getCityLpPage());
  }, []);

  //comment
  //GETTING DATA FROM STORE (CITIES NAME) STARTS HERE
  const navCity = useSelector((state) => state.LpCityListReducer.LpCityList);
  const dispatch = useDispatch();

  const location = useLocation();
  ///${position}
  console.log("loacation",location)
  var url = `https://redcliffelabs.com${location.pathname}/${position ? position : ""}/${location.search}`;

  //var url = `https://redcliffelabs.com${location.pathname}/${position}`;

  //HANDEL USERNAME FUNCTON BELOW THIS COMMENT
  const handelUserName = (e) => {
    // setshowPopUp()
    setUserName(e.target.value);
    const characterRegex =/^([A-Za-z]+[ ]?)+$/;
    setNameEror("");
    if (!e.target.value.match(characterRegex)) {
      setNameEror("invalid user name");
    }
    if (e.target.value == "") {
      setNameEror("");
    }
  };

  //HANDEL USEPHONE FUNCTION BELOW THIS COMMENT 2
  const validatePhoneNumber = () => {
    let phoneno = /[^\d]/g;
    if (
      !userNumber.match(phoneno) ||
      parseInt(userNumber[0]) < 6 ||
      userNumber.length < 12
    ) {
      if (userNumber === "") {
        return false;
      } else {
        setPhoneEror("Enter a valid number");
        return false;
      }
    } else {
      return true;
    }
  };

  const handleCheckChange = (e) => {
    setCheckboxState(!checkboxState);
  };

  const handleCaptcha = (e) => {
    setInputCaptcha(e.target.value);
    if (e.target.value !== Captcha) {
      setErrorCaptcha("Invalid Captcha");
    } else {
      setErrorCaptcha("");
    }
  };

  const normalizeInput = (value, previousValue) => {
    // return nothing if no value
    if (!value) return value;

    // only allows 0-9 inputs
    const currentValue = value.replace(/[^\d]/g, "");
    const cvLength = currentValue.length;

    if (!previousValue || value.length > previousValue.length) {
      // returns: "x", "xx", "xxx"
      if (cvLength < 4) return currentValue;

      // returns: "(xxx)", "(xxx) x", "(xxx) xx", "(xxx) xxx",
      if (cvLength < 7)
        return `${currentValue.slice(0, 3)}-${currentValue.slice(3)}`;

      // returns: "(xxx) xxx-", (xxx) xxx-x", "(xxx) xxx-xx", "(xxx) xxx-xxx", "(xxx) xxx-xxxx"
      return `${currentValue.slice(0, 3)}-${currentValue.slice(
        3,
        6
      )}-${currentValue.slice(6, 10)}`;
    }
  };

  const handelUserEmail = (e) => {
    // setshowPopUp()
    setUserEmail(e.target.value);
  };
  //HANDEL USEPHONE FUNCTION BELOW THIS COMMENT 1
  const handelPhoneChange = (e, userNumber) => {
    // setshowPopUp()
    setUserNumber(normalizeInput(e.target.value, userNumber));
    // setUserNumber(e.target.value);
    setPhoneEror("");
  };

  useEffect(() => {
    if (location.pathname.includes("/lp-taboola/")) {
      setleadSource("lp-taboola");
      console.log("hai ismai");
    } else {
      setleadSource("Ecommerce");
    }
  }, []);

  const handelSubmit = (e) => {
    e.preventDefault();
    const checkVal = validatePhoneNumber();
    if (checkVal) {
      const body = {
        optin: checkboxState,
        name: userName,
        phone_no: userNumber.replaceAll("-", ""),
        source: leadSource,
        email: userEmail,
        city: userCity,
        url,
      };
      console.log(body);
      setUserNumber("");
      setUserName("");
      setUserCity("");
      setUserEmail("");
      setSucess(true);
      openSucess(true);
      setTimeout(() => {
        setSucess(false);
      }, 2000);
      dispatch(getCall(body));
      // history.push({
      //   search: "?/ThankYou",
      // });
    }
  };

  const setInputcity = (val) => {
    setUserCity(val);
    setDisplay(false);
  };

  const handelCityChange = (e) => {
    // setshowPopUp()
    setUserCity(e.target.value);
    setDisplay(true);
  };
  //model div
  const SuccessModel = ({ number }) => {
    return (
      <div className="SuccessMsg_upload">
        <h2>
          We have received your information. We shall call you in few minutes to
          confirm the details. For any queries please call us at &nbsp;
          <a href={`tel:+91-${number}`} style={{ color: "blue" }}>
            {number}
          </a>{" "}
          - Team Redcliffe Labs
        </h2>
      </div>
    );
  };

  // const genFormId = () => {
  //   if (isMobile && formId) {
  //     return `Mobile${formId}`;
  //   } else if (!isMobile && formId) {
  //     return formId;
  //   } else if (!isMobile && !formId) {
  //     return "lpBottom";
  //   }
  // };

  return (
    <form id={formId ? formId : "normalForm"} onSubmit={handelSubmit}>
      <div className="form__div">
        {/* <h4>Book Your Test</h4> */}

        {emailType && emailTitle !== "" ? (
          <h4 className="staticHeader">{emailTitle}</h4>
        ) : isLp && title == "" ? null : (
          <h4>{title ? title : "Book Your Test"}</h4>
        )}
        {isLp ? (
          <div className="freeHome">
            {" "}
            <span style={{ fontWeight: "400" }}>With</span>{" "}
            {offerPrice > minPhleboCharge ? "FREE" : null} HOME SAMPLE
            COLLECTION
          </div>
        ) : null}
        <div>
          <div className="form__input numBox">
            <span className="userIcon">
              <FaUserCircle />
            </span>
            <div className="inputDiv">
              <input
                type="text"
                placeholder="Enter Name"
                style={{ border: "none" }}
                onChange={handelUserName}
                value={userName}
              />
            </div>
          </div>
          <span className="FormError">{nameError}</span>
        </div>

        {/* <div className="phone_number">
                    +91 */}
        <div>
          <div className="form__input numBox">
            <span className="numIcon">+91</span>
            <div className="inputDiv">
              <input
                onBlur={() => {
                  validatePhoneNumber();
                }}
                type="text"
                placeholder="Enter Phone Number"
                required
                style={{ border: "none" }}
                onChange={handelPhoneChange}
                value={userNumber}
              />
            </div>
          </div>
          <span className="FormError">{phoneError}</span>
        </div>
        {emailType ? (
          <div>
            <div className="form__input numBox">
              <span className="userIcon">
                <MdEmail />
              </span>
              <div className="inputDiv">
                <input
                  type="email"
                  required
                  placeholder="Enter Email Id"
                  onChange={handelUserEmail}
                  value={userEmail}
                />
              </div>
            </div>
            <span className="FormError"> </span>
          </div>
        ) : null}
        <div>
          <div className="citySelect">
            <span className="locIcon">
              {" "}
              <FaMapPin />{" "}
            </span>

            <input
              type="text"
              // onBlur={()=> setCityFocus(true)}
              placeholder="Enter City"
              onChange={handelCityChange}
              // style={{ border: "none" }} 
              value={userCity}
            />

            {/* <AiFillCaretDown /> */}
            {/**CITY LIST ARRAY BELOW */}
            <div
              className={
                userCity && displayCityList ? "cityList" : "displayNone"
              }
              id="cityList"
            >
              {userCity !== "" && navCity && navCity.cities
                ? navCity.cities
                    .filter((name) => {
                      if (userCity == "") {
                        return name;
                      } else if (
                        name.toLowerCase().includes(userCity.toLowerCase())
                      ) {
                        return name;
                      }
                    })
                    .map((values, index) => {
                      if (index < 2) {
                        return (
                          <>
                            <div
                              onClick={() => setInputcity(values)}
                              key={index}
                              className={
                                displayCityList ? "cityLIstLP" : "displayNone"
                              }
                            >
                              <span>{values}</span>
                            </div>
                          </>
                        );
                      }
                    })
                : null}
            </div>
          </div>
        </div>
        <div className="LP_opt_Div formMargin">
          <input
            type="checkbox"
            onChange={() => handleCheckChange()}
            defaultChecked
            style={{ width: "22px", height: "22px" }}
          />

          <span className="watsap">
            <RiWhatsappFill className="wtsapIcon" />
          </span>
          <span className="textt">Opt-in for WhatsApp updates </span>
        </div>

        <button
          id={buttonId ? buttonId : "normalButton"}
          type="submit"
          disabled={
            isLp
              ? nameError || disable
                ? "disabled"
                : ""
              : nameError
              ? "disabled"
              : ""
          }
          className={
            isLp
              ? nameError || disable
                ? "disabled"
                : ""
              : nameError
              ? "disabled"
              : ""
          }
        >
          {butname ? butname : "SUBMIT"}
        </button>
      </div>
      <Modal open={openSuccModel} onClose={closeSuccess} center>
        <SuccessModel number={number} />
      </Modal>
    </form>
  );
};

export default LpForm;
